/**
 * Sel-2 CTA scroll targets
 * Resolves data-scroll-target / in-page #sel-2-* hrefs with sticky-header offset.
 */
(function () {
  'use strict';

  var FALLBACKS = ['#sel-2-product-selector', '[data-sel-2-product-selector]'];
  var EXTRA_GAP = 56;

  function normalizeId(raw) {
    return String(raw || '').trim().replace(/^#/, '');
  }

  function resolveTarget(raw) {
    var value = String(raw || '').trim();
    if (!value || value === '#') return null;

    // Allow #id, bare id, .class, or other CSS selectors
    if (value.charAt(0) === '#' || value.charAt(0) === '.' || value.charAt(0) === '[') {
      try {
        var bySelector = document.querySelector(value);
        if (bySelector) return bySelector;
      } catch (err) {
        /* ignore invalid selector */
      }
    }

    var id = normalizeId(value);
    if (id) {
      var byId = document.getElementById(id);
      if (byId) return byId;
    }

    var i;
    for (i = 0; i < FALLBACKS.length; i += 1) {
      var fallback = document.querySelector(FALLBACKS[i]);
      if (fallback) return fallback;
    }

    return null;
  }

  function getStickyOffset() {
    var sticky = document.querySelector('.sel-2-header--sticky, [data-sel-2-header].sel-2-header--sticky');
    if (sticky) {
      return Math.ceil(sticky.getBoundingClientRect().height) + EXTRA_GAP;
    }
    return window.matchMedia('(max-width: 749px)').matches ? 72 + EXTRA_GAP : 88 + EXTRA_GAP;
  }

  function scrollToWithOffset(target) {
    var offset = getStickyOffset();
    var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    // Keep CSS scroll-margin in sync for native hash / focus behavior
    target.style.scrollMarginTop = offset + 'px';
  }

  document.addEventListener(
    'click',
    function (e) {
      var link = e.target.closest(
        'body.sel-2-main-layout #MainContent a[data-scroll-target], body.sel-2-main-layout #MainContent a[class*="__cta"][href^="#"]'
      );
      if (!link) return;

      var raw = link.getAttribute('data-scroll-target') || link.getAttribute('href') || '';
      if (!raw || raw === '#' || raw.indexOf('http') === 0) return;
      // Only handle in-page anchors / selectors
      if (raw.charAt(0) !== '#' && raw.charAt(0) !== '.' && raw.indexOf('sel-2-') !== 0) return;

      var target = resolveTarget(raw);
      if (!target) return;

      e.preventDefault();
      e.stopPropagation();
      scrollToWithOffset(target);
    },
    true
  );
})();
